import { render, staticRenderFns } from "./TangibleAssetsTool.vue?vue&type=template&id=c31e6856&"
import script from "./TangibleAssetsTool.vue?vue&type=script&lang=js&"
export * from "./TangibleAssetsTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports